var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bx-layout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.036,
    height: 26.036,
    viewBox: "0 0 26.036 26.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 26.036,
    height: 26.036,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M19.5,7.5h-.385A3.794,3.794,0,0,0,19.5,5.85a3.838,3.838,0,0,0-6.6-2.683A3.838,3.838,0,0,0,6.3,5.85,3.794,3.794,0,0,0,6.684,7.5H6.3A3.3,3.3,0,0,0,3,10.8V13a1.1,1.1,0,0,0,1.1,1.1H5.2v6.6A3.3,3.3,0,0,0,8.5,24h8.8a3.3,3.3,0,0,0,3.3-3.3V14.1h1.1A1.1,1.1,0,0,0,22.8,13V10.8A3.3,3.3,0,0,0,19.5,7.5ZM11.8,21.8H8.5a1.1,1.1,0,0,1-1.1-1.1V14.1h4.4Zm0-9.9H5.2V10.8A1.1,1.1,0,0,1,6.3,9.7h5.5Zm0-4.4h-1.65A1.65,1.65,0,1,1,11.8,5.85ZM14,5.85a1.65,1.65,0,1,1,1.65,1.65H14ZM18.4,20.7a1.1,1.1,0,0,1-1.1,1.1H14V14.1h4.4Zm2.2-8.8H14V9.7h5.5a1.1,1.1,0,0,1,1.1,1.1Z",
    transform: "translate(0.166 -0.272)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.36aa01853a9c3a147325bffc41dfe30c.svg";
export { ForwardRef as ReactComponent };